import Alerts from './alerts'
import DashboardOverview from './DashboardOverview'

const DashboardHome = () => {
  return (
    <>
      <DashboardOverview />
      {/* <Alerts /> */}
    </>
  )
}

export default DashboardHome
